import { topicsData } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">热门话题</h2>
        <div className="flex flex-wrap gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium cursor-pointer whitespace-nowrap transition-all hover:scale-105 active:scale-95 ${colorMap[topic.color] || colorMap.primary}`}
            >
              <span>{topic.name}</span>
              <span className="text-xs opacity-70 font-semibold">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}